// eslint-disable-next-line no-unused-vars
import React from "react";
import {Input, Label} from "react-aria-components";
import "./Fields.css"
import WrappedWithErrorMessage from "../ErrorMessage/ErrorMessage.jsx";
import {LuEye, LuEyeOff} from "react-icons/lu";

export function LabeledTextField({label, hiddenLabel, name, placeholder, value, onChange, errorLoc, inputType="text", className, togglableMasking} : {
    label?: string,
    hiddenLabel?: string,
    name: string,
    placeholder?: string,
    value?: string,
    onChange: (value: string) => void,
    errorLoc?: Array<string>,
    inputType?: "text" | "password" | "email" | "number",
    className?: string,
    togglableMasking?: boolean
}) {
    let [inputTypeVal, setInputType] = React.useState(inputType);
    let labelElement = null;
    if (label) {
        labelElement = <Label className="labeled-text-field-label" id={label + "id"}>{label}</Label>
    }

    let maskingElement = null;
    if(togglableMasking) {
        maskingElement = <span className="masking-toggle" onClick={() => {
            if (inputTypeVal === "text") {
                setInputType("password");
            } else {
                setInputType("text");
            }
        }}>
            {inputTypeVal === "text" ? <LuEye/> : <LuEyeOff/>}
        </span>
    }
    return <div className={className ? className + " labeled-text-field" : "labeled-text-field"} aria-labelledby={label + "id"}>
        <WrappedWithErrorMessage errorLoc={errorLoc} >
            {labelElement}
            <Input
                type={inputTypeVal}
                placeholder={placeholder}
                name={name}
                defaultValue={value ? value : ""}
                onChange={onChange}

                aria-labelledby={label+'id'}
                aria-label={hiddenLabel}
            />
            {maskingElement}
        </WrappedWithErrorMessage>
    </div>


}

export function LabeledSection({label, children, icon, className}:{label: string, children?: Array<any>, icon?: any, className?: string}) {
    let cn = "labeled-section";
    if(className){
        cn = cn + " " + className
    }
    return <fieldset className={cn} aria-label={label}>
        <legend>{icon} {label}</legend>
        {children}
    </fieldset>
}
